// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ticker-wrap-multi-line[data-v-a02fbe92]{color:#000;max-width:100%;overflow-x:hidden;white-space:nowrap;z-index:1}.ticker-text[data-v-a02fbe92]{font-size:1.75rem}@media screen and (max-width:767px){.ticker-text[data-v-a02fbe92]{font-size:1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
